export default {
    props: { departments: Object },
    computed: {
        
    }, 
    methods:{
      
    }

}